import { ColumnType } from 'antd/es/table'
import StampWriteOff from '../../../../types/api/stamp-write-off'
import { Button, Space } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import UserCell from '../../../../components/user-cell/user-cell'
import renderDatetime from '../../../../helpers/tables/render-datetime'
import FormModal from '../../../../components/form-modal/form-modal'
import StampWriteOffForm from '../../../../components/forms/stamp-write-off-form/stamp-write-off-form'
import Title from 'antd/es/typography/Title'

export const getColumns: (
    onSuccessUpdate: () => void
) => ColumnType<StampWriteOff>[] = onSuccessUpdate => [
    {
        dataIndex: ['stamp', 'number'],
        title: 'Номер',
        width: 100,
    },
    {
        dataIndex: 'reason',
        title: 'Причина списания',
        width: 100,
    },
    {
        dataIndex: ['initiator', 'username'],
        title: 'Ответственный за поломку',
        width: 100,
        render(value, record, index) {
            return <UserCell username={value} />
        },
    },
    {
        dataIndex: 'createdAt',
        title: 'Создано',
        width: 100,
        render: renderDatetime,
    },
    {
        dataIndex: '1',
        title: 'Действия',
        // fixed: 'right',
        // width: 100, // without compact
        width: 80,
        render: (_, record) => {
            return (
                <Space>
                    <FormModal
                        width={800}
                        renderContent={onClose => (
                            <>
                                <Title level={2} style={{ marginTop: 0 }}>
                                    Списание штампа
                                </Title>
                                <StampWriteOffForm
                                    stampWriteOff={record}
                                    onSuccess={() => {
                                        onSuccessUpdate()
                                        onClose()
                                    }}
                                />
                            </>
                        )}
                        renderOpener={onOpen => (
                            <Button
                                icon={<EditOutlined />}
                                title={'Редактировать списание'}
                                size={'small'}
                                onClick={onOpen}
                            />
                        )}
                    />

                    {/* <Link to={dynamicRoutes.writeOffsStampWriteOff(record.documentId)}> */}
                    {/* <Button
                            icon={<EditOutlined />}
                            title={'Редактировать списание'}
                            size={'small'}
                        /> */}
                    {/* </Link> */}
                </Space>
            )
        },
    },
]
